// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"PageHeader_PageHeader__2DrRD","Container":"PageHeader_Container__3t1bx","DesktopOnly":"PageHeader_DesktopOnly__3bAU0","SideMenu":"PageHeader_SideMenu__sGljw"};